import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import SurveyEditCoreForm from './SurveyEditCoreForm';

export class SurveyEditCore extends Component {
  render() {
    const {
      onCancel, onSave,
      initialValues,
    } = this.props;

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={async (values, formikBag) => {
          const { resetForm } = formikBag;
          await onSave(values, resetForm);
        }}
        render={formProps => (
          <SurveyEditCoreForm
            formProps={formProps}
            onCancel={onCancel}
          />
        )}
      />
    );
  }
}

SurveyEditCore.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
};

const EditForm = SurveyEditCore;
export default EditForm;
